interface MiniFitProps {
  title: string
  score: number
  subtitle: string
  sample?: boolean
}

export function MiniFitCard({title, score, subtitle, sample}: MiniFitProps) {
  return (
    <div className="rounded-xl border border-border-light bg-surface-light p-3 space-y-2">
      <div className="flex items-center justify-between">
        <div className="text-sm font-medium">{title}</div>
        <div className="flex items-center gap-2">
          {sample && (
            <span className="text-[10px] px-2 py-0.5 rounded border border-border-light bg-surface text-brand-glow">sample</span>
          )}
          <span className="text-xs px-2 py-0.5 rounded border border-border-light bg-surface text-ink">{score}</span>
        </div>
      </div>
      <div className="text-xs text-muted">{subtitle}</div>
    </div>
  )
}
